<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Staff",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Staff",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "email",
          sortable: true,
          label: "EMAIL",
        },
        {
          key: "gender",
          sortable: true,
          label: "GENDER",
        },
        {
          key: "position",
          sortable: true,
          label: "POSITION",
        },
        {
          key: "join_date",
          sortable: true,
          label: "DATE JOINED",
        },
        {
          key: "nok",
          sortable: true,
          label: "NEXT OF KEEN",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingStaff: [],
      nameError: "",
      contactError: "",
      genderError: "",
      positionError: "",

      // Value from user input for adding unit
      data: {
        name: "",
        contact: "",
        other_contact:"",
        gender:"",
        email:"",
        address:"",
        position:"",
        nin:"",
        nok_contact:"",
        nok:"",
        device_id:"",
        join_date:"",
        does_delivery:0,
        commission_percentage:0
      },
      // edit unit
      editdata: {
        name: "",
        contact: "",
        other_contact:"",
        gender:"",
        email:"",
        address:"",
        position:"",
        nin:"",
        nok_contact:"",
        nok:"",
        join_date:"",
        does_delivery:0,
        commission_percentage:0,
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("staff", ["StaffSave", "Staff", "StaffPositions"]),
    ...mapGetters("auth", ["MyUserPerm","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Staff ? this.Staff.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Staff ? this.Staff.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
          this.resetEdit();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchAllStaff",
      FetchStaffPositions: "staff/fetchStaffPositions",
      AddStaff: "staff/addStaff",
      EditStaff: "staff/editStaff",
      DeleteStaff: "staff/deleteStaff",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addStaff(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Name  field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateStaff()
      if (this.contactError!=""){
        return
      }
      if (this.data.gender === "") {
        this.genderError = "Gender field is required";
        return;
      } else {
        this.genderError = "";
      }

      if (this.data.position === "") {
        this.positionError = "Position field is required";
        return;
      } else {
        this.positionError = "";
      }

      this.AddStaff(this.data);
    },

    validateStaff(){
      if (this.data.name !="" && this.data.contact!=''){
        let selStaff = this.Staff.filter((item)=>{
          return  item.contact ==  parseInt(this.data.contact);
        })
        let staffCount =selStaff.length;
        if (staffCount>0){
          this.contactError="Staff with contact "+this.data.contact+"  already Exists";
        }
      }
    },

    resetAdd() {
      this.data.name = "";
      this.data.contact = "";
      this.data.other_contact = "";
      this.data.gender = "";
      this.data.email = "";
      this.data.address = "";
      this.data.position = "";
      this.data.nin = "";      
      this.data.nok = "";
      this.data.nok_contact = "";
      this.data.join_date = "";
      this.data.does_delivery = 0;
      this.data.commission_percentage = 0;
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.contact = "";
      this.editdata.other_contact = "";
      this.editdata.gender = "";
      this.editdata.email = "";
      this.editdata.address = "";
      this.editdata.position = "";
      this.editdata.nin = "";      
      this.editdata.nok = "";
      this.editdata.nok_contact = "";
      this.editdata.join_date = "";
      this.editdata.does_delivery = 0;
      this.editdata.commission_percentage = 0;
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.contactError = "";
      this.genderError = "";
      this.positionError = "";
    },
    showEditModal(val) {
      this.editdata.name = val.item.name;
      this.editdata.contact = val.item.contact;
      this.editdata.gender = val.item.gender;
      this.editdata.email = val.item.email;
      this.editdata.address = val.item.address;
      this.editdata.position = val.item.position_id;
      this.editdata.nin = val.item.nin;
      this.editdata.nok = val.item.nok;
      this.editdata.nok_contact = val.item.nok_contact;
      this.editdata.join_date = val.item.join_date;
      this.editdata.does_delivery = val.item.does_delivery;
      this.editdata.commission_percentage = val.item.commission_percentage;
      this.editdata.id = val.item.id;
    },
    editStaff(modalId) {
      this.modal_id = modalId;
      this.validateStaffEdit()
      if (this.contactError!=""){
        return;
      }
      // this.EditStaff(this.editdata);
       this.EditStaff(this.editdata).then(()=>{
        this.FetchStaff();
      }) 
    },
    validateStaffEdit(){
      if (this.editdata.name !="" && this.editdata.contact!=''){
        let selStaff = this.Staff.filter((item)=>{
          return  (item.contact ==  parseInt(this.editdata.contact)) && (item.id != this.editdata.id) ;
        })
        let staffCount =selStaff.length;
        if (staffCount>0){
          this.contactError="Staff with contact "+this.editdata.contact+"  already Exists";
        }
      }
    },
    showDeleteModal(val) {
      this.deletedata.name = val.item.name;
      this.deletedata.id = val.item.id;
    },
    deleteStaff(modalId) {
      this.modal_id = modalId;
      this.DeleteStaff(this.deletedata).then(()=>{
        this.FetchStaff();
      })  
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStaff();
    this.FetchStaffPositions();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Staff</h4>
              </div>
              <div v-if="MyUserPerm.add_staff == 1 && branchid != 0" class="col-md-3" align="right">
                <b-button v-b-modal.add_staff-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="Staff?Staff:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(gender)="data">
                  {{ data.item.gender == 1?'Male':'Female' }}
                </template>
                <template #cell(actions)="data">
                <b-button-group>
                  <b-button
                      v-if="MyUserPerm.edit_staff == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-staff-modal
                      @click="showEditModal(data)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      size="sm"
                      v-if="MyUserPerm.delete_staff == 1"
                      variant="danger"
                      v-b-modal.delete-staff-modal
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader  v-if="!Staff"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add_staff-modal" no-close-on-backdrop
    no-close-on-esc size="lg" hide-footer>
      <template #modal-title> Add Staff </template>

      <div class="row">
        <div class="form-group mb-3 col-6">
          <label>Staff Name <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter Name "
                class="form-control"
                @input="resetError()"
                v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>

        <div class="form-group mb-3 col-6">
          <label>Staff Contact</label>
          <div class="input-group">
            <input
                type="number"
                placeholder="Enter Phone Number"
                class="form-control"
                v-model="data.contact"
                @input="resetError()"
            />
          </div>
          <div class="text-danger" v-if="contactError">
            <em>{{ contactError }}</em>
          </div>
        </div>

        <div class="form-group mb-3 col-6">
          <label>Other Contact</label>
          <div class="input-group">
            <input
                type="number"
                placeholder="Enter Other Phone Number"
                class="form-control"
                v-model="data.other_contact"
                @input="resetError()"

            />
          </div>
        </div>

        <div class="form-group mb-3 col-6">
          <label>Email Address</label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter Email address "
                class="form-control"
                @input="resetError()"
                v-model="data.email"
            />
          </div>
        </div>
        <div class="form-group mb-3 col-6">
          <label>Gender</label>
          <div class="input-group">
            <select
                type="text"
                class="form-control"
                v-model="data.gender"
                @change="resetError()"
            >
            <option value="">Select Gender</option>
            <option value="1">Male</option>
            <option value="2">Female</option>
            </select>
          </div>
           <div class="text-danger" v-if="genderError">
            <em>{{ genderError }}</em>
          </div>
        </div> 
        <div class="form-group mb-3 col-6">
          <label>Address</label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter address "
                class="form-control"
                v-model="data.address"
                @input="resetError()"
            />
          </div>
        </div> 
        <div class="form-group mb-3 col-6">
          <label>Staff Position</label>
          <div class="input-group">
            <model-list-select
                :list="StaffPositions ? StaffPositions : []"
                v-model="data.position"
                option-value="id"
                option-text="name"
                placeholder="Select Position"
                @change="resetError()"
            >
            </model-list-select>
          </div>
           <div class="text-danger" v-if="positionError">
            <em>{{ positionError }}</em>
          </div>
        </div>
        <div class="form-group mb-3 col-6">
          <label>NIN</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter NIN "
              class="form-control"
              v-model="data.nin"
            />
          </div>
        </div>
        <div class="form-group mb-3 col-6">
          <label>Next of Kin</label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter Next of Kin"
                class="form-control"
                v-model="data.nok"
            />
          </div>
        </div>
        <div class="form-group mb-3 col-6">
          <label>Next of Kin Contact</label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter Next of Kin Contact"
                class="form-control"
                v-model="data.nok_contact"
            />
          </div>
        </div>
        <div class="form-group mb-3 col-6">
          <label>Dated Joined</label>
          <div class="input-group">
            <input
                type="date"
                placeholder="Select date when staff joined"
                class="form-control"
                v-model="data.join_date"
                v-limit-future-date
            />
          </div>
        </div>
        <div class="form-group mb-3 col-6">
          <label>Does delivery</label>
          <div class="input-group">
            <select
                type="text"
                placeholder="Specify for delivery personel"
                class="form-control"
                v-model="data.does_delivery"
            >
            <option value="0">No</option>
            <option value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group mb-3 col-6" v-if="GeneralSettings.commission_on_sales == 1">
          <label>Commission Percentage</label>
          <div class="input-group">
            <input
                type="text"
                placeholder="Enter Commission %ge"
                class="form-control"
                v-model="data.commission_percentage"
            />
          </div>
        </div>
      </div>      

      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add_staff-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="addStaff('add_staff-modal')"
        > <i class="fa fa-check"></i>
          Submit
          <b-spinner
              v-if="StaffSave"
              variant="light"
              small
              label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--edit modal starts-->
        <b-modal id="edit-staff-modal" no-close-on-backdrop
        no-close-on-esc size="lg" hide-footer @hidden="resetEdit">
          <template #modal-title> Edit Staff {{ editdata.name }}</template>
          <div class="row">
            <div class="form-group mb-3 col-6">
              <label>Staff Name <span class="text-danger">*</span></label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Name "
                    class="form-control"
                    @input="resetError()"
                    v-model="editdata.name"
                />
              </div>
              <div class="text-danger" v-if="nameError">
                <em>{{ nameError }}</em>
              </div>
            </div>

            <div class="form-group mb-3 col-6">
              <label>Staff Contact</label>
              <div class="input-group">
                <input
                    type="number"
                    placeholder="Enter Phone Number"
                    class="form-control"
                    v-model="editdata.contact"
                    @input="resetError()"

                />
              </div>
              <div class="text-danger" v-if="contactError">
                <em>{{ contactError }}</em>
              </div>
            </div>

            <div class="form-group mb-3 col-6">
              <label>Other Contact</label>
              <div class="input-group">
                <input
                    type="number"
                    placeholder="Enter Other Phone Number"
                    class="form-control"
                    v-model="editdata.other_contact"
                    @input="resetError()"

                />
              </div>
            </div>

            <div class="form-group mb-3 col-6">
              <label>Email Address</label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Email address "
                    class="form-control"
                    @input="resetError()"
                    v-model="editdata.email"
                />
              </div>
            </div>
            <div class="form-group mb-3 col-6">
              <label>Gender</label>
              <div class="input-group">
                <select
                    type="text"
                    class="form-control"
                    v-model="editdata.gender"
                >
                <option value="">Select Gender</option>
                <option value="1">Male</option>
                <option value="2">Female</option>
                </select>
              </div>
            </div> 
            <div class="form-group mb-3 col-6">
              <label>Address</label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter address "
                    class="form-control"
                    @input="resetError()"
                    v-model="editdata.address"
                />
              </div>
            </div> 
            <div class="form-group mb-3 col-6">
              <label>Staff Position</label>
              <div class="input-group">
                <model-list-select
                    :list="StaffPositions ? StaffPositions : []"
                    v-model="editdata.position"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Position"
                >
                </model-list-select>
              </div>
            </div>
            <div class="form-group mb-3 col-6">
              <label>NIN</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter NIN "
                  class="form-control"
                  v-model="editdata.nin"
                />
              </div>
            </div>
            <div class="form-group mb-3 col-6">
              <label>Next of Kin</label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Next of Kin"
                    class="form-control"
                    v-model="editdata.nok"
                />
              </div>
            </div>
            <div class="form-group mb-3 col-6">
              <label>Next of Kin Contact</label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Next of Kin Contact"
                    class="form-control"
                    v-model="editdata.nok_contact"
                />
              </div>
            </div>
            <div class="form-group mb-3 col-6">
              <label>Dated Joined</label>
              <div class="input-group">
                <input
                    type="date"
                    placeholder="Select date when staff joined"
                    class="form-control"
                    v-model="editdata.join_date"
                    v-limit-future-date
                />
              </div>
            </div>            
            <div class="form-group mb-3 col-6">
              <label>Does delivery</label>
              <div class="input-group">
                <select
                    type="text"
                    placeholder="Specify for delivery personel"
                    class="form-control"
                    v-model="editdata.does_delivery"
                >
                <option value="0">No</option>
                <option value="1">Yes</option>
                </select>
              </div>
            </div>
            <div class="form-group mb-3 col-6" v-if="GeneralSettings.commission_on_sales == 1">
              <label>Commission Percentage</label>
              <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Commission %ge"
                    class="form-control"
                    v-model="editdata.commission_percentage"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('edit-staff-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-primary"
                @click="editStaff('edit-staff-modal')"
            > <i class="fa fa-check"></i>
              Save Changes
              <b-spinner
                  v-if="StaffSave"
                  variant="light"
                  small
                  label="Saving"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
    <!-- modal ends -->

    <!-- modal delete staff starts -->
    <b-modal
        header-bg-variant="danger"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="danger"
        footer-text-variant="danger"
        id="delete-staff-modal"
        hide-footer
        @hidden="resetDelete"
    >
      <template #modal-title> Delete Staff {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-staff-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteStaff('delete-staff-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="StaffSave"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>